import { Component, OnInit } from '@angular/core';
import {AchooPieChartComponent} from '../../../../core/achoo-pie-chart/achoo-pie-chart.component';
import {PdfExportService} from '../../../../services/export-pdf/pdf-export.service';
import {UserService} from '../../../../services/user.service';
import {TranslateService} from '@ngx-translate/core';
import {chartConfig, GenderEnum} from '../../../../app.constants';
import {DeviceDetectorService} from 'ngx-device-detector';
import {InfluencerDemographicGender} from '../../influencer-demographics/influencer-demographics.component';

@Component({
  selector: 'demographic-gender-chart',
  templateUrl: './demographic-gender-chart.component.html',
  styleUrls: ['./demographic-gender-chart.component.scss']
})
export class DemographicGenderChartComponent extends AchooPieChartComponent implements OnInit {
  chart: any;
  public readonly femaleColor: string;
  public readonly maleColor: string;

  constructor(protected pdfService: PdfExportService,
              protected userService: UserService,
              protected translate: TranslateService,
              protected deviceService: DeviceDetectorService) {
    super(pdfService, userService, translate, deviceService);

    this.femaleColor = userService.chartColors[GenderEnum.FEMALE];
    this.maleColor = userService.chartColors[GenderEnum.MALE];
  }

  ngOnInit() {
    this.options = {
      chart: {
        height: this.height,
        type: chartConfig.type.pie,
        margin: [0, 0, 0, 0],
        spacingTop: 0,
        spacingBottom: 0,
        spacingLeft: 0,
        spacingRight: 0,
        style: {
          fontFamily: chartConfig.font.light
        },
      },
      colors: this.userService.chartColors,
      tooltip: {
        enabled: false
      },
      plotOptions: {
        pie: {
          size: '100%',
          height: '100%',
          dataLabels: {
            enabled: false
          },
          showInLegend: false
        },
        series: {
          animation: !this.pdfService.exportingPdf
        }
      },
      legend: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },
      series: [{
        data: this.normalizeChartData(this.chartData),
        size: this.pieSize || chartConfig.pieChart.size,
        innerSize: this.pieInnerSize || chartConfig.pieChart.innerSize
      }]
    };
  }

  saveInstance(chartInstance) {
    this.chart = chartInstance;
  }

  showHideLegend() {
    if (!this.chart) {
      return;
    }
    this.chart.series[0].points[1].onMouseOver();
  }

  genderPercent(gender: string) {
    if (!this.chartData) {
      return null;
    }
    const femaleData = this.chartData.find(c => c.name.toLowerCase() === gender);
    return femaleData ? femaleData.y * 100 : null;
  }

  clickLegend(legend) {
    if (!this.chart) {
      return;
    }
    this.chart.series[0].points.forEach((p) => {
      if (p.name.toLowerCase() === legend) {
        const isVisible = p.visible;
        const updatedPoint = Object.assign({}, p, {
          visible: !isVisible
        });
        p.update(updatedPoint);
      }
    });
  }

  hoverLegend(legend) {
    if (!this.chart) {
      return;
    }
    this.chart.series[0].points.forEach(p => {
      if (p.name.toLowerCase() === legend) {
        p.onMouseOver();
      }
    });
  }

  isVisibleLegend(legend) {
    if (!this.chart) {
      return false;
    }
    const activePoint = this.chart.series[0].points.find(p => p.name.toLowerCase() === legend);
    return activePoint && activePoint.visible;
  }

  private normalizeChartData(chartData) {
    if (!chartData) {
      return [];
    }
    const female = InfluencerDemographicGender.Female.toString().toLowerCase();
    return chartData.map(c => ({
        name: c.name,
        y: c.y,
        x: c.name.toLowerCase() === female ? GenderEnum.FEMALE : GenderEnum.MALE,
        color: c.name.toLowerCase() === female ? this.femaleColor : this.maleColor
    }));
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/demographic/demographic-gender-chart/demographic-gender-chart.component.ts